import React from 'react';
import './Features.css';
import { FaLock, FaCarSide, FaShippingFast, FaLeaf } from 'react-icons/fa';
import { useI18n } from '../../i18n/I18n';

const Features: React.FC = () => {
  const { t } = useI18n();
  return (
    <section className="features-section">
      <div className="features-container">
        <div className="feature-card">
          <div className="feature-icon">
            <FaLock />
          </div>
          <h3 className="feature-title">{t('features.card1.title')}</h3>
          <p className="feature-desc">{t('features.card1.desc')}</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">
            <FaLeaf />
          </div>
          <h3 className="feature-title">{t('features.card4.title')}</h3>
          <p className="feature-desc">{t('features.card4.desc')}</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">
            <FaCarSide />
          </div>
          <h3 className="feature-title">{t('features.card2.title')}</h3>
          <p className="feature-desc">{t('features.card2.desc')}</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">
            <FaShippingFast />
          </div>
          <h3 className="feature-title">{t('features.card3.title')}</h3>
          <p className="feature-desc">{t('features.card3.desc')}</p>
        </div>
      </div>
    </section>
  );
};

export default Features; 